import { SyntheticEvent } from 'react'
import { Position, Range } from 'types'
import { MediaSprite, TextStyle } from '../../types'
import Renderer from './classes/renderer'
import Shader from './classes/shader'

export const artboardFilters = ['grayscale', 'rainbow', 'rumble', 'vhs', 'wavy'] as const
export type ArtboardFilter = (typeof artboardFilters)[number]

export interface ArtboardRef {
    createGIF: (crop?: Position) => Promise<File | null>
    createSprite: (crop?: Position) => Promise<MediaSprite | null>
    getProgress: () => number
    setProgress: (progress: number) => void
}

export interface ArtboardLoopRef {
    paused: boolean
    progress: number
    pause: () => void
    play: () => void
    scrub: (progress: number) => void
}

export interface ArtboardRasterizedRef {
    renderer: Renderer | null
}

export type ArtboardLayerProps = {
    className?: string
    draggable?: boolean
    height: number
    mirrored?: boolean
    persistFocus?: boolean
    rotation?: number
    timing?: Range
    width: number
    x?: number
    y?: number
    zIndex?: number
    onContextMenu?: (e: SyntheticEvent<HTMLElement, MouseEvent>) => void
    onDoubleClick?: (e: SyntheticEvent<HTMLElement, MouseEvent>) => void
    onDraw?: (position: Position, shader: Shader) => void
    onEllipsisMenu?: (e: SyntheticEvent<HTMLElement, MouseEvent>) => void
    onFocusChange?: (focused: boolean) => void
    onPositionUpdate?: (position: Position, isDragging: boolean) => void
}

export interface ArtboardGifLayerProps extends ArtboardLayerProps {
    reversed?: boolean
    source: File | string
}

export interface ArtboardImageLayerProps extends ArtboardLayerProps {
    source: File | string
}

export interface ArtboardSpriteLayerProps extends ArtboardLayerProps {
    reversed?: boolean
    source: MediaSprite | null
}

export interface ArtboardTextLayerProps extends Omit<ArtboardLayerProps, 'height'>, Partial<TextStyle> {
    text: string
}

export interface ArtboardTextureLayerProps extends ArtboardLayerProps {
    source: TexImageSource | null
}
